import { render, staticRenderFns } from "./CounterArgumentBanner.vue?vue&type=template&id=3ef84832&scoped=true"
import script from "./CounterArgumentBanner.vue?vue&type=script&lang=ts"
export * from "./CounterArgumentBanner.vue?vue&type=script&lang=ts"
import style0 from "./CounterArgumentBanner.vue?vue&type=style&index=0&id=3ef84832&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef84832",
  null
  
)

export default component.exports